// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSupportFormMutationVariables = Types.Exact<{
  site?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  topic?: Types.InputMaybe<Types.Scalars['String']['input']>;
  message?: Types.InputMaybe<Types.Scalars['String']['input']>;
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
  files?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type SubmitSupportFormMutation = { __typename?: 'Mutation', knowYourCustomerSubmitSupportForm?: { __typename?: 'KnowYourCustomerSubmitSupportFormPayload', success?: boolean, errors?: Array<{ __typename?: 'KnowYourCustomerError', message?: string, params?: Array<{ __typename?: 'KnowYourCustomerErrorParam', value?: string }> }> } };


export const SubmitSupportFormMutationDocument = /*#__PURE__*/ gql`
    mutation SubmitSupportFormMutation($site: String, $email: String, $topic: String, $message: String, $language: String, $files: [String]) {
  knowYourCustomerSubmitSupportForm(
    input: {site: $site, email: $email, topic: $topic, message: $message, language: $language, files: $files}
  ) {
    success
    errors {
      message
      params {
        value
      }
    }
  }
}
    `;
export type SubmitSupportFormMutationMutationFn = Apollo.MutationFunction<SubmitSupportFormMutation, SubmitSupportFormMutationVariables>;
export function useSubmitSupportFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSupportFormMutation, SubmitSupportFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSupportFormMutation, SubmitSupportFormMutationVariables>(SubmitSupportFormMutationDocument, options);
      }
export type SubmitSupportFormMutationHookResult = ReturnType<typeof useSubmitSupportFormMutation>;
export type SubmitSupportFormMutationMutationResult = Apollo.MutationResult<SubmitSupportFormMutation>;
export type SubmitSupportFormMutationMutationOptions = Apollo.BaseMutationOptions<SubmitSupportFormMutation, SubmitSupportFormMutationVariables>;